import { useCallback, useEffect, useState } from 'react'
import axios from 'axios'
import config from 'config'

const useSessionsCurrentSession = () => {
  const [currentSession, setCurrentSession] = useState({
    fetching: false,
  })

  const fetchCurrentSession = useCallback(async () => {
    setCurrentSession({ fetching: true })

    const { data } = await axios.get(`${config.apiBaseUrl}sessions/current`)

    setCurrentSession({ data: data?.body, fetching: false })
  }, [])

  useEffect(() => {
    fetchCurrentSession()
  }, [fetchCurrentSession])

  return {
    currentSession,
  }
}

export default useSessionsCurrentSession
